import React from "react";
import "../TDSRecon.css";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import BoxWrapper from "../../../../../components/ui/boxWrapper";

function MYBooksDetails(props) {
  const { booksDetails } = props;
  const [search, setSearch] = React.useState("");
  const [tableData, setTableData] = React.useState(booksDetails);

  // indian rupeess system---
  const indianRupeesFormat = (value) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumSignificantDigits: 10,
    }).format(value);
  // ---End---

  const handleTableSearch = (event) => {
    setSearch(event.target.value);
    let searchData = booksDetails.filter((item) => {
      const query = event.target.value.toLowerCase();
      return (
        (item.financial_year || "").toLowerCase().includes(query) ||
        (item.quarter || "").toLowerCase().includes(query) ||
        (item.customer_name || "").toLowerCase().includes(query) ||
        (item.customer_gstin || "").toLowerCase().includes(query) ||
        (item["customer/decuctor_tan"] || "").toLowerCase().includes(query)
      );
    });
    setTableData(searchData);
  };

  return (
    <>
      <BoxWrapper
        boxTitle="Reference data as per Payment advice"
        // search input
        enableSearchInput={true}
        searchInputPlaceholder="Search..."
        searchInputOnchange={handleTableSearch}
      >
        <div className="responsive-table">
          <table className="custome-table">
            <thead>
              <tr>
                <th>Customer Name</th>
                <th>PAN</th>
                <th>TAN</th>
                <th>Financial Year</th>
                <th>TDS Quarter</th>
                <th>Invoice Number</th>
                <th>Invoice date</th>
                <th>Payment advice date</th>
                <th>TDS per Payment advice</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{item.customer_name}</td>
                    <td>{item.cust_pan}</td>
                    <td>{item["customer/decuctor_tan"]}</td>
                    <td>FY {item.financial_year}</td>
                    <td>Q {item.quarter}</td>
                    <td>{item.invoice_number}</td>
                    <td>{item.invoice_date}</td>
                    <td>{item.payment_advice_date}</td>
                    <td>{indianRupeesFormat(item.tds_per_payment_advice)}</td>
                  </tr>
                );
              })}
              {tableData.length === 0 && (
                <tr>
                  <td colSpan={9} style={{ color: "red", textAlign: "center" }}>
                    No Data Found!
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </BoxWrapper>
    </>
  );
}

export default MYBooksDetails;
